<template>
  <div class="v-subheader">
    <template v-if="fieldLines">
      Lineas {{ linesUsed }}/{{ linesTotal }}
      <span class="ml-2 error--text" v-if="overflowPos">
        {{ $t('message.milenium.textOverflowFrom', { from: overflowPos }) }}
      </span>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    fieldLines: {
      type: Object,
    },
  },
  computed: {
    linesUsed() {
      if (!this.fieldLines) return null;
      return this.fieldLines.linesUsed;
    },
    linesTotal() {
      if (!this.fieldLines) return null;
      return this.fieldLines.linesTotal;
    },
    overflowPos() {
      if (!this.fieldLines) return null;
      return this.fieldLines.overflowPos;
    },
  },
};
</script>
